import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category/news", label: "动漫资讯" },
  { to: "/category/recommend", label: "番剧推荐" },
  { to: "/category/character", label: "角色介绍" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
      isActive
        ? "text-accent-600"
        : "text-foreground-700 hover:text-foreground-950"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-foreground-950 font-black text-lg font-display">
              蕉
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display font-black text-lg text-foreground-950">香蕉动漫</span>
              <span className="text-[10px] tracking-widest text-foreground-500">BANANA ANIME</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:block">
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 w-56 focus-within:border-primary-400 transition-colors">
                <i className="ri-search-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索资讯 / 番剧 / 角色"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
            </form>

            <Link
              to="/search"
              aria-label="搜索"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </Link>

            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 animate-banana-fade">
            <form onSubmit={handleSearch} className="mb-3">
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
                <i className="ri-search-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索资讯 / 番剧 / 角色"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-100 text-accent-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}